import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_MAP_SHOW_VEHICLE } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import TripMap from '../../components/TripMap';

export const Route = createFileRoute('/_authenticated/trip-map/')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_MAP_SHOW_VEHICLE, ['read'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'ridePlayer.title',
        // suffix: 'menu.carSettings',
      },
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: TripMapIndexRoute,
});

function TripMapIndexRoute() {
  // const { id } = Route.useParams();

  return <TripMap />;
}
